import "./selectBox.css";

function SelectBox({
  selectClass,
  textValue,
  options,
  selectedValue,
  setSelectedValue,
}) {
  return (
    <select
      className={`${selectClass} ${selectedValue ? "selected" : ""}`}
      value={selectedValue}
      onChange={(e) => setSelectedValue(e.target.value)}
    >
      <option value="">{textValue}</option>
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
}

export default SelectBox;
